<template>
  <section id="container" class="gnb_pdt">
    <div>
      <div class="title_wrap">
        <h1>긴급공지 설정</h1>
      </div>
    </div>
    <!--  기본 정보  -->
    <div class="contents_wrap">
      <ul class="filter_list">
        <li>
          <dd>
            <label>키오스크 ID</label>
            <ul class="w75">
              <li>
                {{ kioskInfo.kioskNo }}
              </li>
            </ul>
          </dd>
          <dd>
            <label>키오스크 용도</label>
            <ul class="w75">
              <template v-for="item in kioskUseScnList ">
                <li v-if="item.cdId == kioskInfo.kioskUseScn">
                  {{item.cdNm}}
                </li>
              </template>
            </ul>
          </dd>
        </li>
        <!-- <li>
          <dd>
            <label>생성 일시</label>
            <ul class="w75">
              <li>
                {{ kioskInfo.frstRgstDt }}
              </li>
            </ul>
          </dd>
          <dd>
            <label>사용 여부</label>
            <ul class="w75">
              <li v-if="kioskInfo.kioskUseYn == 'Y'" >
                {{ '사용' }}
              </li>
              <li v-else>
                {{ '미사용' }}
              </li>
            </ul>
          </dd>
        </li> -->
        <li>
          <dd>
            <label>키오스크 명</label>
            <ul class="w75">
              <li>
                {{ kioskInfo.kioskNm }}
              </li>
            </ul>
          </dd>
          <!-- <dd>
            <label>사용자 인증</label>
            <ul class="w75">
              <li v-if="kioskInfo.certyYn == 'Y'" >
                {{ '사용' }}
              </li>
              <li v-else>
                {{ '미사용' }}
              </li>
            </ul>
          </dd> -->
        </li>
        <li>
          <dd>
            <li>
              <label>사업장/거점</label>
              <ul class="w75">
                <li>
                  {{ kioskInfo.facilityNm }}<span class="mgl10"> {{ kioskInfo.areaNm }}</span>
                </li>
              </ul>
            </li>
            <li>
              <label>건물/층</label>
              <ul class="w75">
                <li>
                  {{ kioskInfo.buildingNm }}<span class="mgl10">{{ kioskInfo.floorNm}}</span>
                </li>
              </ul>
            </li>
          </dd>
          <!-- <dd>
            <label>키오스크 담당자</label>
            <ul>
              <li v-for="item in kioskInfo.kioskManagerList" class="f_l w30 ">
                {{item.userNm + '( ' +item.spTelNo + ' )'}}
              </li>
            </ul>
          </dd> -->
        </li>
      </ul>
    </div>
    <!--  긴급 공지 설정 영역  -->
    <div class="contents_wrap">
      <ul class="filter_list">
        <li>
          <dd>
            <label>긴급공지 사용 여부</label>
            <ul class="w75">
              <li>
                <div v-for="item in [{cdId:'Y',cdNm:'사용'},{cdId:'N',cdNm:'미사용'}]">
                  <input
                      class="k-radio"
                      type="radio"
                      name="emergencyUseYnRef"
                      :id="`${item.cdNm}_emergencyUseYn`"
                      :value="item.cdId"
                      v-model="emergencyInfo.emergencyUseYn"
                      @change="onChangeEmergencyUseYn()"
                  >
                  <label :for="`${item.cdNm}_emergencyUseYn`" class="k-radio-label" style="width:100px">{{ item.cdNm }}</label>
                </div>
              </li>
            </ul>
          </dd>
          <dd>
            <label>시작 시간 ~ 종료 시간<span v-show="isEmergencyUseYn" class="forg">*</span></label>
            <ul class="w75">
              <li >
                <kendo-datetimepicker
                    ref="startDtRef"
                    :format="'MM/dd/HH:mm'"
                    :value="emergencyInfo.startDt"
                    :interval="5"
                    :disabled="!isEmergencyUseYn"
                    @change="setDt()"
                >
                </kendo-datetimepicker>
                ~
                <kendo-datetimepicker
                    ref="endDtRef"
                    :format="'MM/dd/HH:mm'"
                    :value="emergencyInfo.endDt"
                    :min="emergencyInfo.startDt"
                    :interval="5"
                    :disabled="!isEmergencyUseYn"
                    @change="setDt"
                >
                </kendo-datetimepicker>
              </li>
            </ul>
          </dd>
        </li>
        <li>
          <dd>
            <label>제목<span v-show="isEmergencyUseYn" class="forg">*</span></label>
            <ul>
              <kendo-maskedtextbox
                  ref="noticeTitleRef"
                  class="w100"
                  :class="{'error' : errorTarget === 'noticeTitle'}"
                  v-model="emergencyInfo.noticeTitle"
                  :disabled="!isEmergencyUseYn"
                  maxlength="50"
              >
              </kendo-maskedtextbox>
            </ul>
          </dd>
        </li>
        <li>
          <dd class="w100">
            <label style="width:9.5%">본문</label>
            <ul class="w90">
              <kendo-maskedtextbox
                  ref="noticeDescriptionRef"
                  class="w100"
                  v-model="emergencyInfo.noticeDescription"
                  :disabled="!isEmergencyUseYn"
                  maxlength="100"
              >
              </kendo-maskedtextbox>
            </ul>
          </dd>
        </li>
      </ul>
    </div>
    <!--  버튼 영역  -->
    <div class="button_area w30">
      <ul>
        <li class="w25">
          <button class="large_btn orange" @click="onClickSave">저장</button>
        </li>
        <li class="w25">
          <button class="large_btn" @click="redirectToList">목록</button>
        </li>
      </ul>
    </div>
  </section>
</template>
<script>
import ApiUtil from "@/api/api.util";
import ApiConfig from "@/api/api.config";
import { DateTimePicker } from '@progress/kendo-dateinputs-vue-wrapper';
import {LogisticsCodeDtlMixin, ZoneMixin} from "@/mixin/Mixin";
import EtnersDatetimeUtil from '@/common/etners.datetime.util'
import EtnersCommonUtil from '@/common/etners.common.util'
export default {
  name: "EmergencySettings",
  components:{
    'kendo-datetimepicker': DateTimePicker
  },
  mixins: [LogisticsCodeDtlMixin, ZoneMixin],
  created() {
    const vm = this
    vm.getKioskDetail()
    vm.getEmergencyInfo()
  },
  methods: {
    // 키오스크 정보 가져오는 메서드
    getKioskDetail() {
      const vm = this

      const param = {
        loginUserToken: vm.loginUserToken,
        kioskNo: vm.$route.params.kioskNo
      }
      const url = `${ApiConfig.eklDomain}/v1/ebmp/ai/manager/portal/kiosk/kioskDetail.json`

      ApiUtil.post(url, param).then(response => {
        if (response.data === undefined || response.data.resultStatus === undefined) {
          kendo.alert('데이터를 정상적으로 받아오지 못했습니다.')
          this.$Progress.fail()
          return false
        }
        const resultStatus = response.data.resultStatus
        if (resultStatus.messageCode !== '2000') {
          kendo.alert(resultStatus.messageText)
          return false
        }
        const resultData = response.data.resultData

        vm.kioskInfo = resultData
      })
    },
    //공지사항 설정 정보 가져오는 메서드
    getEmergencyInfo() {
      const vm = this
      const refs = vm.$refs

      const url = `${ApiConfig.eklDomain}/v1/ebmp/ai/manager/portal/kiosk/emergencyDetail.json`
      const param = {
        loginUserToken: vm.loginUserToken,
        kioskNo: vm.$route.params.kioskNo
      }

      ApiUtil.post(url, param).then(response => {
        if (response.data === undefined || response.data.resultStatus === undefined) {
          kendo.alert('데이터를 정상적으로 받아오지 못했습니다.')
          this.$Progress.fail()
          return false
        }
        const resultStatus = response.data.resultStatus
        if (resultStatus.messageCode !== '2000') {
          kendo.alert(resultStatus.messageText)
          return false
        }
        const resultData = response.data.resultData
        vm.emergencyInfo = resultData
        //시작일, 종료일이 지정되지 않았을 경우, 현재시간기준으로 초기화
        if(!!vm.emergencyInfo.startDt){
          vm.emergencyInfo.startDt = new Date(vm.emergencyInfo.startDt)
        } else {vm.emergencyInfo.startDt = new Date()}
        if(!!vm.emergencyInfo.endDt){
          vm.emergencyInfo.endDt = new Date(vm.emergencyInfo.endDt)
        } else {vm.emergencyInfo.endDt = new Date()}
        vm.onChangeEmergencyUseYn()
      })
    },
    // dateRangePicker에 선택한 시간 초기화
    setDt(){
      const vm = this
      vm.emergencyInfo.startDt = vm.$refs.startDtRef.kendoWidget().value()
      vm.emergencyInfo.endDt = vm.$refs.endDtRef.kendoWidget().value()
      // 시작일이 종료일보다 큰경우, 종료일 초기화
      if(vm.emergencyInfo.startDt > vm.emergencyInfo.endDt){
        vm.emergencyInfo.endDt = vm.$refs.endDtRef.kendoWidget().value('')
      }
    },
    // 긴급공지 사용 안하는 경우 하단 설정창 disable 처리
    onChangeEmergencyUseYn() {
      const vm = this
      if (vm.emergencyInfo.emergencyUseYn === 'Y' ){
        vm.isEmergencyUseYn = true;
      }
      else if (vm.emergencyInfo.emergencyUseYn === 'N' ){
        vm.isEmergencyUseYn = false;
      }
    },
    // 목록으로 이동
    redirectToList(){
      const vm = this
      vm.$router.push({
        name: 'KioskList'
      })
    },
    // 저장 버튼
    async onClickSave () {
      const vm = this
      if (vm.validation()) {
        vm.saveEmergency()
      }
    },
    // 예외처리 메서드
    validation() {
      const vm = this
      const emergencyInfo = vm.emergencyInfo

      if(emergencyInfo.emergencyUseYn === 'Y'){
        if(EtnersCommonUtil.isEmpty(emergencyInfo.noticeTitle)){
          kendo.alert('긴급공지 제목을 입력해주세요.')
          vm.errorTarget = 'noticeTitle'
          return
        }
        if(EtnersDatetimeUtil.isEmpty(emergencyInfo.startDt)){
          kendo.alert('긴급공지 시작시간을 설정하세요.')
          vm.errorTarget = null
          return
        }
        if(EtnersDatetimeUtil.isEmpty(emergencyInfo.endDt)){
          kendo.alert('긴급공지 종료시간을 설정하세요.')
          vm.errorTarget = null
          return
        }
      }
      vm.errorTarget = null
      return true
    },
    // 긴곱공지 저장
    saveEmergency(){
      const vm = this
      const url = `${ApiConfig.eklDomain}/v1/ebmp/ai/manager/portal/kiosk/emergencySave.json`
      const param = {
        loginUserToken: vm.loginUserToken,
        emergencyUseYn: vm.emergencyInfo.emergencyUseYn,
        startDt : vm.emergencyInfo.startDt,
        endDt : vm.emergencyInfo.endDt,
        noticeTitle : vm.emergencyInfo.noticeTitle,
        noticeDescription : vm.emergencyInfo.noticeDescription,
        kioskNo : vm.kioskInfo.kioskNo,
        noticeType : '02',
      }
      kendo.confirm("긴급공지사항을 저장하시겠습니까?").done(()=>{
        ApiUtil.post(url,param).then(response => {
          if (response.data === undefined || response.data.resultStatus === undefined){
            kendo.alert('데이터를 정상적으로 받아오지 못했습니다.')
            return false
          }
          const resultStatus = response.data.resultStatus
          if (resultStatus.messageCode !== '2000'){
            kendo.alert(resultStatus.messageText)
            return false
          }
          kendo.alert('수정되었습니다.')
          vm.redirectToList()
        })
      })
    }
  },
  data() {
    const vm = this
    return {
      loginUserToken: sessionStorage.getItem('loginUserToken'),
      kioskInfo: {},
      emergencyInfo: {},
      isEmergencyUseYn : false,
      startDt : new Date(),
      endDt : new Date(),
      errorTarget: null,
    }
  }
}
</script>
